import crestUrl from './polonia-forged-crest.png';

export function LoadingCrest({ label }: { label?: string }) {
  return (
    <div className="polonia-loading-overlay" role="status" aria-live="polite">
      <div className="polonia-loading-crest-wrap">
        <span className="polonia-loading-halo" />
        <img src={crestUrl} alt="" className="polonia-loading-crest" />
        {label && <small>{label}</small>}
      </div>
    </div>
  );
}
